import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserModel } from 'src/app/models/UserModel';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private message: string;
    constructor(private router: Router, private user: UserModel) { }

    /** this is used to clear anything that needs to be removed */
    clear(): void {
        localStorage.clear();
    }
    /** check for expiration and if token is still existing or not
     * @return {boolean}
     */
    isAuthenticated(): boolean {
        if (localStorage.getItem('user_credentials')) {
            const token = JSON.parse(localStorage.getItem('user_credentials')).loginResponse.token;
            return token !== null && token !== '';
        }
        return false;
    }

    /**
     * this is used to clear local storage and also the route to login
     */
    logout(): void {
        if(!this.user.rememberMe) {
            this.clear();
        }
        this.router.navigate(['/login']);
    }
}
